import { createRootRoute, Outlet } from "@tanstack/react-router";
import { RootLayout } from "#shared/components/root-layout/root-layout.tsx";

export const Route = createRootRoute({
  component: () => (
    <RootLayout>
      <Outlet />
    </RootLayout>
  ),
});
